<!-- navbar -->
<nav class="navbar navbar-default navbar-custom navbar-fixed-top" data-spy="affix" data-offset-top="100">
	<div class="top-bar">
		<div class="container">
			<div class="row">
				<ul class="contact">
					<li class="phone">
						<i class="fa fa-mobile" aria-hidden="true"></i>
						<span>{{generalInfo.companyPhone}} - {{generalInfo.hotline}}</span>
					</li>
					<li class="mail hidden-xs">
						<i class="fa fa-envelope-o" aria-hidden="true"></i>
						<span>{{generalInfo.email}}</span>
					</li>
					<li class="time hidden-xs">
						<i class="fa fa-clock-o" aria-hidden="true"></i>
						<span>T2 - T7: 8AM - 17PM </span>
					</li>
				</ul>
				<ul class="social">
					<li *ngFor="let item of socials">
						<a href="{{item.path}}"><i class="fa {{getSocial(item.code)}}" aria-hidden="true"></i></a>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<div class="bottom-nav" style="padding: 5px 0;">
		<div class="container">
			<div class="row">
				<div class="navbar-header">
					<button type="button" class="navbar-toggle collapsed" data-toggle="collapse"
						data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
						<span class="sr-only">Toggle navigation</span>
						<span class="icon-bar"></span>
						<span class="icon-bar"></span>
						<span class="icon-bar"></span>
					</button>
					<a class="navbar-brand" href="/"><img alt="" src="assets/App_Themes/image/logo.png"
							srcset="assets/App_Themes/image/logo.png 1x, assets/App_Themes/image/logo2x.png 2x"></a>
				</div>

				<!-- Collect the nav links, forms, and other content for toggling -->
				<div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
					<ul class="nav navbar-nav ">
						<li *ngFor="let item of menus"><a [routerLink]="item.code">{{item.name}}</a></li>

						<li><a class="btn btn-quote trns-btn" href="/lien-he">Báo giá</a></li>
					</ul>
				</div>
				<!-- /.navbar-collapse -->
			</div>
		</div>
	</div>
</nav>
<!-- End navabr -->